// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608032307/js/" + chunkId + "." + {"44":"8fb259e4","225":"30bc08c2","481":"3c54299c","486":"22b79407","770":"d4ea309b"}[chunkId] + ".0.6939109266460527.chunk.js";
};